<template>
  <VModalWidget :visible="offline">
    <template slot="title">
      {{ $t('title') }}
    </template>

    <template slot="content">
      {{ $t('description') }}
    </template>

    <template slot="footer-actions">
      <v-btn depressed color="default" @click="reload">{{ $t('reload') }}</v-btn>
    </template>
  </VModalWidget>
</template>

<script>
import { mapGetters } from 'vuex'
import { NAMESPACE } from '../store'
import VModalWidget from './VModalWidget'

export default {
  name: 'Offline',
  components: {
    VModalWidget
  },
  computed: {
    ...mapGetters(NAMESPACE, ['offline'])
  },
  methods: {
    reload() {
      location.reload()
    }
  }
}
</script>

<i18n>
{
  "en": {
    "description": "We're sorry but the service is currently unavailable. Please reload or try again later.",
    "reload": "@:labels.reload",
    "title": "Service Unavailable"
  },
  "fr": {
    "description": "Nous sommes désolés mais le service est actuellement indisponible. Veuillez recharger ou réessayer plus tard.",
    "reload": "@:labels.reload",
    "title": "Service indisponible"
  }
}
</i18n>
